import React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';
import classes from './AutoCompleteStyles';
export default function AutoCompleteItem(props) {
    const { query, queryLabel, queryType, isFirst = false, isSelected = false, index, submitQuery, handleAutocompleteItemSelect, } = props;
    function highlightQuery(queryLabelString) {
        let newString = queryLabelString;
        const newQuery = query.trim().toLowerCase().replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
        const matchIndex = queryLabelString.toLowerCase().replace(/[-\\^$*+?.()|[\\]{}]/g, '\\$&').indexOf(newQuery);
        if (matchIndex !== -1) {
            const regEx = new RegExp(newQuery, 'ig');
            const partialMatch = queryLabelString.substr(matchIndex, newQuery.length);
            newString = queryLabelString.replace(regEx, `<em>${partialMatch}</em>`);
        }
        return newString;
    }
    function handleMouseOver() {
        handleAutocompleteItemSelect(index);
    }
    return (React.createElement(ListItemButton, { onClick: (e) => submitQuery(e, queryLabel, queryType), onMouseDown: (e) => submitQuery(e, queryLabel, queryType), onMouseOver: handleMouseOver, onKeyDown: (e) => submitQuery(e, queryLabel, queryType), selected: isSelected, disableGutters: true, dense: true, sx: classes.autoCompleteItemWrapper },
        React.createElement(Typography, { id: "searchQueryType", component: "span", sx: classes.searchQueryType }, !isFirst ? '' : queryType),
        React.createElement(Typography, { component: "span", sx: classes.searchQueryName }, parse(highlightQuery(queryLabel) || ''))));
}
